let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("do1d5")).then(() => parcelRequire('EfGdX'));